import { Injectable } from '@angular/core'
import { FormatDataService } from './format.data.service'
import { Assignment, KeyBitArray } from '../models/dev.test.models'
import { LoggingService } from './logging.service'

@Injectable({
  providedIn: 'root',
})
export class AssignmentService {
  constructor(private formatDataService: FormatDataService, private loggingService: LoggingService) {}

  assignKbas(data) {
    this.loggingService.log('Assigning', data)
    // this.unassignKbas(data)
    this.formatDataService.assignBittings(data.masterkeys, data.selectedKbaArray, data.selectedBook, {
      skipGuidelineViolators: data.rules.skipGuidelineViolators,
    })
    return this.prepareAssignmentRequest(data)
  }

  prepareAssignmentRequest(data) {
    data.assignedMasterKeyBittings
    data.selectedBook
    return (data.assignedMasterKeyBittings = this.formatDataService.prepareAssignmentRequest(data.selectedBook))
  }

  unassignKbas(data) {
    data.selectedKbaArray.forEach((kba: KeyBitArray) => {
      if (kba.assignment && kba.assignment.masterKey) {
        this.loggingService.log('Unassign MasterKey', kba.assignment.masterKey)
        let key = data.selectedMasterKey.children.find((k) => k.id === kba.assignment.masterKey.id)
        key.assignment = new Assignment()
        kba.assignment = new Assignment()
        key.unassignedLocally = true
        key.isAssignedLocally = false
      }

      if (kba?.assignment?.reservationType?.id && !data.rules.skipReserved) {
        this.loggingService.log('Unassign Reserved', kba?.assignment?.reservationType)
        kba.assignment = new Assignment()
      }

      kba.selected = false
    })
    this.prepareAssignmentRequest(data)
  }
}

export class AssignmentData {
  masterkeys
  selectedKbaArray
  selectedMasterKey
  selectedBook
  assignedMasterKeyBittings
  rules: {
    skipGuidelineViolators
    skipReserved
  }
}
